<template>
  <div class="table-column-filter">
    <button
      class="btnFilter"
      :class="{ '-active': show }"
      @click="show = !show"
    >
      {{ title }}

      <span class="icon"><ion-icon name="chevron-down-outline"></ion-icon></span>
    </button>

    <div class="filterArea" v-if="show">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TableColumnFilter',

  props: {
    title: {
      required: false,
      type: String,
    },
  },

  data() {
    return {
      show: false,
    };
  },

  methods: {
    /**
     * Check if element are inside a table-column-filter component.
     *
     * @param el
     * @returns {boolean}
     */
    elementAreInsideUser(el) {
      try {
        let node = el.parentNode;

        while (node != null) {
          if ((node.className || '').indexOf('table-column-filter') > -1) {
            return true;
          }

          node = node.parentNode;
        }

        return false;
      } catch {
        return false;
      }
    },
  },

  mounted() {
    document.addEventListener('click', ({ target }) => {
      const elementAreInsideFilter = this.elementAreInsideUser(target);

      if (this.show && !elementAreInsideFilter) {
        this.show = false;
      }
    });
  },
};
</script>

<style lang="scss" scoped>
.table-column-filter {
  @apply w-full;

  > .btnFilter {
    @apply text-secondary-800;
    @apply text-xs;
    @apply font-bold;
    @apply text-left;
    @apply relative;
    @apply w-full;
    outline: none;

    > .icon {
      @apply absolute;
      right: 0;
      top: 50%;
      transform: translateY(-50%);
      height: 18px;
      width: 18px;
      @apply flex;
      @apply justify-center;
      @apply items-center;
    }

    &.-active {
      > .icon {
        @apply bg-primary-500;
        @apply text-white;
        @apply rounded;
        box-shadow: 0px 0px 4px 0px rgb(115 102 255 / 60%);
      }
    }
  }

  > .filterArea {
    width: 250px;
    position: absolute;
    z-index: 12;
    top: 70%;
    right: 0;
    background: #fff;
    box-shadow: 0 0 10px rgba(89,102,122,0.3);
    border-color: #e2e8f0;
    box-sizing: border-box;
    display: flex;
    border-radius: 4px;
    flex-wrap: wrap;
    padding: 10px;
  }
}
</style>
